// extracted by css-extract-rspack-plugin
export default {"msg":"msg-vRbk4M","do":"do-xEDkQ9","dont":"dont-mhKXwa"};